import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';

function Button({
    className, children, content, type, customBg, icon, margin, size, onClick, iconMargin, iconClassName, isSubmit, padding, rounded, disabled, loading, iconSize, displayLabel,
})
{
    return (
        <button
            data-display-label={displayLabel}
            onClick={onClick}
            disabled={disabled}
            className={`tw-transition-all ${disabled ? 'tw-cursor-not-allowed' : ''} ${rounded || 'tw-rounded'} ${size === 'sm' && `tw-text-[10px] ${padding || 'tw-pb-1 tw-pt-1.5 tw-px-2'}`} ${size === 'md' && `tw-text-sm ${padding || 'tw-pb-1 tw-pt-1.5 tw-px-5'}`} ${customBg}
            ${type === 'primary' && `dark:tw-text-button-primary-textdark dark:tw-bg-button-primary-backgrounddark tw-text-button-primary-text tw-bg-button-primary-background ${disabled ? ' tw-opacity-70 ' : 'dark:hover:tw-bg-primary-default dark:hover:tw-text-button-primary-text hover:tw-bg-primary-hover hover:tw-text-primary-hover-text '} `}
            ${type === 'danger' && 'tw-text-white tw-bg-danger-darkest'}
            ${type !== 'custom' && 'tw-font-normal'}
            ${type === 'secondary' && ' tw-opacity-90 dark:tw-text-button-secondary-textdark dark:tw-bg-button-secondary-backgrounddark tw-text-button-secondary-text tw-bg-button-secondary-background'} ${margin} hover:tw-opacity-100 ${className}`}
            type={isSubmit ? 'submit' : 'button'}
        >
            { icon && loading && <LoadingSpinner loading className={`${iconMargin || 'tw-mr-4'}`} /> }
            { icon && !loading && (<FontAwesomeIcon icon={icon} size={iconSize} className={`${iconMargin || 'tw-mr-4'} ${iconClassName}`} />)}
            <span className="tw-pt-1">
                {children}
                {content}
            </span>
        </button>
    );
}

Button.defaultProps = {
    content: '',
    type: 'primary',
    margin: 'tw-mt-4',
    customBg: '',
    size: 'md',
    onClick: null,
    isSubmit: false,
    disabled: false,
    loading: false,
};

Button.propTypes = {
    children: PropTypes.node,
    content: PropTypes.node,
    rounded: PropTypes.string,
    customBg: PropTypes.string,
    className: PropTypes.string,
    padding: PropTypes.string,
    iconSize: PropTypes.string,
    margin: PropTypes.string,
    type: PropTypes.string,
    isSubmit: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    icon: PropTypes.object,
    size: PropTypes.string,
    onClick: PropTypes.func,
    iconClassName: PropTypes.string,
    iconMargin: PropTypes.string,
    displayLabel: PropTypes.string,
};

export default Button;
